import en1 from './en1'
export default {

  route: {
    platmanagemtnt: 'Platform',
    branchlist: 'Branches',
    fabriclist: 'Fabric Suppliers',
    myaccount: 'Fund Account',
    designers: 'Designers',
    '客户取货方式': 'Pickup Method',
    '邮寄': 'Mail',
    '收货地址': 'Address',
    '顺丰ID': 'SF ID',
    '物流信息': 'Logistics',
    '物流公司': 'Courier',
    '发货': 'Ship',
    '收货人': 'Receiver',
    '收货人电话': 'Receiver Phone',
    '联系方式': 'Contact',
    '售后订单': 'After-sales',
    '预售订单': 'Pre-sale',
    '详情': 'Details',
    '处理': 'Process',
    '待接收订单': 'Pending Orders',
    '已接收订单': 'Accepted Orders',
    '手动派单': 'Manual Dispatch',
    '平台版师': 'Platform Designer',
    '入驻版师': 'Designer',
    '支付时间': 'Pay Time',
    '商品退款': 'Product Refund',
    '邮寄费用': 'Shipping Fee',
    '退邮寄费': 'Shipping Refund',
    '券减免': 'Coupon Discount',
    '售后事项': 'After-sales',
    '退款商品': 'Refund Product',
    '货物状态': 'Goods Status',
    '退款原因': 'Refund Reason',
    '退款金额': 'Refund Amt',
    '相关图片': 'Photos',
    '同意退款': 'Approve',
    '拒绝退款': 'Reject',
    '签收货物': 'Confirm Receipt',
    '确认签收': 'Confirm Receipt',
    '确认退款': 'Confirm Refund',
    '确定要作废这个订单吗': 'Void this order?',
    '视频安装': 'Video Install',
    '安装时间': 'Install Time',
    '安装人': 'Installer',
    '安装状态': 'Install Status',
    '安装备注': 'Install Note',
    '请选择安装时间': 'Select install time',
    '请选择安装人': 'Select installer',
    '请选择安装状态': 'Select install status',
    '课程退款': 'Course Refund',
    '课程名称': 'Course',
    '支付并开通': 'Pay & Activate',
    '修改价格': 'Edit Price',
    '原始订单金额': 'Original Amt',
    '新订单金额': 'New Amt',
    '已开通': 'Activated',
    '已提交': 'Submitted',
    '已支付': 'Paid',
    '已作废': 'Voided',
    '刷新': 'Refresh',
    '当前没有未派送的订单': 'No pending orders',
    '成衣图片': 'Product Image',
    '客户体型': 'Body Meas.',
    '暂无客户体型图片': 'No body images',
    '饰品信息': 'Accessory Info',
    '抢单': 'Accept',
    '自动匹配': 'Auto Match',
    '撤销更改': 'Undo',
    '保存量体尺码': 'Save Sizes',
    '正在下载文件中请稍后': 'Downloading, please wait...',
    '加载中': 'Loading...',
    '下载当前客户版型': 'Download Pattern',
    '下载团体客户版型': 'Download Group Pattern',
    '产品标题': 'Product',
    '下载': 'Download',
    '成衣型号': 'Model',
    '售后状态': 'After-sales',
    '订单状态': 'Order Status',
    '退款发起日期': 'Refund Date',
    '货运信息': 'Shipping Info',
    '面料号': 'Fabric No.',
    '饰品号': 'Accessory No.',
    '我的订单': 'My Orders',
    '专属版型': 'Exclusive',
    '新增订单': 'New Order',
    '纸质版型': 'Paper Pattern',
    '线下量体': 'Offline Measure',
    '下载团体客户数据': 'Download Group Data',
    '面料订单': 'Fabric Orders',
    '辅料订单': 'Accessory Orders',
    '账户支付': 'Account Pay',
    '已取件': 'Picked Up',
    '运输中': 'In Transit',
    '已签收': 'Signed',
    '已发货': 'Shipped',
    '待发货': 'Pending',
    '多状态': 'Multi',
    '运单号': 'Tracking No.',
    '送至': 'Deliver to',
    '设置顺丰ID': 'Set SF ID',
    '请录入顺丰ID': 'Enter SF ID',
    '邮费': 'Shipping',
    '打印费': 'Print Fee',
    '退打印费': 'Print Refund',
    '已完成打印': 'Done Print',
    '已打印': 'Printed',
    '打印': 'Print',
    '订单已发货': 'Shipped!',
    '版型已打印': 'Printed!',
    '未收到货': 'Not Received',
    '已收到货': 'Received',
    '不想要了': 'No longer needed',
    '协商一致退款': 'Mutual agreement',
    '空包裹': 'Empty package',
    '快递一直未送到': 'Not delivered',
    '商品破损已拒签': 'Damaged, rejected',
    '客户申请退货退款': 'Return requested',
    '买家退货': 'Buyer return',
    '退款完毕': 'Refund done',
    '客户寄回货物': 'Customer return',
    '商家同意退货': 'Seller approved',
    '等待接收退货说明': 'Waiting for returned goods.',
    '商家拒绝退货': 'Seller rejected',
    '拒绝原因': 'Reject reason',
    '回复时间': 'Reply time',
    '商家已退款': 'Refunded',
    '退款成功时间': 'Refund time',
    '请录入拒绝原因': 'Enter reject reason',
    '确认签收并退款': 'Confirm & Refund',
    '确认签收提示': 'Confirm receipt and refund?',
    '确认退款提示': 'Order not shipped, refund total',
    '您确认退款吗': 'Confirm refund?',
    '收件人': 'Receiver:',
    '收件人电话': 'Receiver Phone:',
    '收件地址': 'Address:',
    '物流信息标签': 'Logistics:',
    '原订单号': 'Original Order:',
    '商品货号': 'Product No.:',
    '退款失败': 'Refund failed',
    '全部门店': 'All Stores',
    '自营平台': 'Platform',
    '重置': 'Reset',
    '批次号': 'Batch No.',
    '量体类型': 'Measure Type',
    '下载个人': 'Download',
    '下载团体': 'Group DL',
    '打印清单': 'Print List',
    '收件人标签': 'Receiver',
    '联系电话标签': 'Phone',
    '收件地址标签': 'Address',
    '购买版型': 'Buy Pattern',
    '购买尺码标签': 'Size',
    '微信扫码查看小程序': 'Scan for Mini Program',
    '微信扫码联系客服': 'Scan for Support',
    '微信扫码查看细节': 'Scan for Details',
    '面料生产提示': 'Choose similar fabrics for best results.',
    '电话标签': 'Phone',
    '网址': 'Website',
    '总接单': 'Total:',
    '今接单': 'Today:',
    '总': 'Total',
    '今': 'Today',
    '请选择需要回复的信息': 'Select reply',
    '输入消息内容': 'Enter message',
    '请输入金额': 'Enter amount',
    '发送': 'Send',
    '出价': 'Quote',
    '咨询': 'Inquiry',
    '企微': 'WeCom',
    '结束': 'End',
    '是否继续': 'Close after-sales order?',
    '是': 'Yes',
    '否': 'No',
    '订单已确认等待付款': 'Order confirmed, awaiting payment.',
    '订单已付款等待发布': 'Paid, awaiting pattern.',
    '请选择待派送订单': 'Select order to dispatch!',
    '请输入物流单号': 'Enter tracking no.',
    '定制图片': 'Custom Images',
    '定制尺码': 'Custom Size',
    '上传附件': 'Upload',
    '请将BOKE文件打包上传': 'Upload BOKE+Size+PLT files',
    '购买版型按钮': 'Buy Pattern',
    '线下预约量体': 'Offline Appointment',
    '面料商': 'Fabric Supplier',
    '金额': 'Amount',
    '公司': 'Company',
    '生产商': 'Manufacturer',
    '成衣生产商': 'Garment Mfr.',
    '成衣生产厂家': 'Garment Manufacturer',
    '输入生产商': 'Enter manufacturer',
    '总接单数': 'Total:',
    '今日接单': 'Today:',
    '待发货标签': 'Pending',
    '到店自取': 'Pickup',
    '物流': 'Logistics:',
    '单号': 'No.:',
    '查看详情': 'Details',
    '接收订单': 'Accept',
    '确定要撤回这个订单吗': 'Withdraw this order?',
    '撤回': 'Withdraw',
    '加工费/生产商': 'Fee/Manufacturer',
    '订单来源': 'Order Source',
    '订单信息': 'Order Info',
    '版型类型': 'Pattern Type',
    '价格': 'Price',
    '总金额': 'Total',
    '名称': 'Name',
    '在线下载': 'Online Download',
    '相同地址合并发货': 'Combine same address',
    '联系地址': 'Address',
    '点击查看详情': 'View details',
    '点击上传版型': 'Upload pattern',
    '点击删除已上传的版型文件': 'Delete uploaded pattern',
    '点击下载订单文件': 'Download order file',
    '已退款': 'Refunded',
    '版型费': 'Pattern Fee',
    '纸质版型订单': 'Paper Pattern Orders',
    '快递商': 'Courier',
    '开通成功提示': 'Activated. Please re-login.',
    '请选择需要开通的会员订单': 'Select membership order',
    '该订单已支付不能修改': 'Order paid, cannot edit',
    '修改成功': 'Updated',
    '订单已分配提示': 'Order already assigned',
    '您已成功接单': 'Order accepted',
    '订单未付款不能发货': 'Unpaid, cannot ship',
    '订单已退款不能发货': 'Refunded, cannot ship',
    '订单已作废不能发货': 'Voided, cannot ship',
    '请填写物流信息': 'Enter logistics info',
    '订单已发货提示': 'Shipped',
    '正在下载文件中': 'Downloading...',
    '售后退款': 'After-sales Refund',
    '退回': 'Return',
    '生产商统一提供': 'Provided by manufacturer',
    '请输入生产商': 'Enter manufacturer',
    '客户姓名手机号订单号': 'Name/Phone/Order No.',
    '智能量体订单': 'Smart Measure Order',
    '匹配范围': 'Range',
    '运费': 'Shipping',
    '成衣预售订单': 'Pre-sale Orders',
    '缺少收件人信息': 'Missing receiver info',
    '订单作废成功': 'Order voided!',
    '请选择是否同意退款': 'Select agree or reject!',
    '售后退款标签': 'After-sales Refund',
    '后台退款备注': 'Backend refund, note:',
    '成衣现货订单': 'Ready-to-wear Orders',
    '高震服装设计': 'Gaozhen Design',
    '分店': 'Branch',
    '饰品退款': 'Accessory Refund',
    '邮寄费': 'Shipping Fee',
    '设计师': 'Designer',
    '接单时间': 'Accept Time',
    '发起时间': 'Create Time',
    '服务时间': 'Service Time',
    '加码订单号': 'Sub Order No.',
    '点击复制': 'Copy',
    '点击下载': 'Download',
    '未打印': 'Not Printed',
    '回复内容不能为空': 'Reply cannot be empty!',
    '没有发现售后订单': 'No after-sales orders found',
    '派单成功': 'Dispatched!',
    '该机构当日接单数量已超限': 'Daily order limit reached.',
    '账号已停用或绑定错误': 'Account disabled or binding error.',
    '请设置发货人信息': 'Set sender info',
    '上传成功': 'Uploaded',
    '的订单已发货': "'s orders shipped!",
    '饰品订单': 'Accessory Orders',
    '量体定制订单': 'Custom Tailored Orders',
    '输入': 'Enter ',
    '自动匹配，匹配范围：': ' auto match, range: ',
    '已退款标签': 'Refunded',
    '退款商品:': 'Refund Product:',
    '货物状态:': 'Goods Status:',
    '退款原因:': 'Refund Reason:',
    '退款金额:': 'Refund Amt:',
    '退款说明:': 'Refund Note:',
    '相关图片:': 'Photos:',
    '会员开通支付订单': 'Membership Orders',
    '支付金额': 'Amount',
    '操作人': 'Operator',
    '订单时间': 'Order Time',
    '操作时间': 'Operate Time',
    '订单类别': 'Category',
    '优惠金额': 'Discount',
    '客户名称': 'Customer',
    '升级级别': 'Level',
    '级别周期': 'Period',
    '级别结束时间': 'End Time',
    '可下载次数': 'Downloads',
    '平台金额': 'Platform Amt',
    '待向平台支付并开通会员': 'Pay to activate membership',
    '价格修改记录': 'Price History',
    '修改人': 'Modified By',
    '修改时间': 'Modified Time',
    '会员下单': 'Member Order',
    '会员升级充值订单': 'Membership Orders',
    '会员升级订单': 'Membership Upgrade Orders',
    '级别开始时间': 'Start Time',
    ...en1
  }
  
}
